import React from 'react';
import PropTypes from 'prop-types';
import './newRadioButton.scss';
import RadioField from './RadioField';

const NewRadioButton = ({ field, formValues, position }) => {
  return field && formValues ? (
    <section id={field.name} className="newRadio-container">
      <h3 id={`${field.name}-label`}>{field.label}</h3>
      <div id={`${field.name}-radio`} className="newRadio-container_radioGroup">
        <span>or</span>
        {field.values &&
          field.values.map((v, index) => {
            let fieldId = `${field.name}-${v.value}`;
            return (
              <RadioField
                id={`${field.name}-${v.label}`}
                key={fieldId}
                field={field}
                fieldId={fieldId}
                v={v}
                index={index}
                checked={
                  formValues && formValues[`q${position + 1}`] && v.label === 'Yes'
                    ? true
                    : !formValues[`q${position + 1}`] && v.label === 'No'
                    ? true
                    : false
                }
              />
            );
          })}
      </div>
    </section>
  ) : null;
};

NewRadioButton.propTypes = {
  field: PropTypes.object,
  formValues: PropTypes.any,
  position: PropTypes.any
};

export default NewRadioButton;
